import { useMemo } from 'react';
import { isWithinBirthdayPeriod } from '../utils';
import { DEFAULT_BIRTHDAY_VOUCHER_DISPLAY_DAYS } from '../constants';
/**
 * Hook to check if customer is eligible for birthday voucher
 * Pure logic - no API calls or Redux dependencies
 */
export var useBirthdayEligibility = function (_a) {
    var birthday = _a.birthday, _b = _a.loyaltyBenefits, loyaltyBenefits = _b === void 0 ? [] : _b, _c = _a.showForDays, showForDays = _c === void 0 ? DEFAULT_BIRTHDAY_VOUCHER_DISPLAY_DAYS : _c;
    return useMemo(function () {
        // Check if customer has birthday voucher benefit
        var hasBirthdayVoucherBenefit = loyaltyBenefits.some(function (benefit) {
            return benefit.name === 'BIRTHDAY_VOUCHER' ||
                benefit.type === 'birthday' ||
                benefit.campaignType === 'birthday';
        });
        if (!birthday || !hasBirthdayVoucherBenefit) {
            return false;
        }
        // Check if within birthday period
        return isWithinBirthdayPeriod(birthday, showForDays);
    }, [birthday, loyaltyBenefits, showForDays]);
};
